import { render, staticRenderFns } from "./InstanceDetails.vue?vue&type=template&id=d945ce5a&scoped=true&"
import script from "./InstanceDetails.vue?vue&type=script&lang=js&"
export * from "./InstanceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d945ce5a",
  null
  
)

export default component.exports